<button type="button" class="close" data-close="true">
  <span aria-hidden="true">&times;</span>
  <span class="sr-only">Close</span>
</button>
<button type="button" id="guides-overlay-button" class="pull-right btn btn-default guides-overlay-button" data-close="true">Enable Guides Overlay</button>
<a href="#" class="pull-right btn btn-default home-button" data-close="true">Home</a>
<div class="page-skipping-container pull-right">
  <label class="caption">Page Skipping</label>
  <div class="btn-group" data-toggle="buttons">
    <label class="btn btn-default btn-xs {{#if pageSkipping}}active{{/if}}">
      <input type="radio" name="page-skipping" id="allowed" autocomplete="off" {{#if pageSkipping}}checked{{/if}} value="true">Allow
    </label>
    <label class="btn btn-default btn-xs {{#unless pageSkipping}}active{{/unless}}">
      <input type="radio" name="page-skipping" id="prevented" autocomplete="off" {{#unless pageSkipping}}checked{{/unless}} value="false">Prevent
    </label>
  </div>
</div>
<div role="tabpanel">
  <ul class="nav nav-tabs tabs" role="tablist">
    <li role="presentation" class="tab active">
      <a href="#course_map_pane" id="course_map" role="tab" data-toggle="tab">Course Map</a>
    </li>
    <li role="presentation" class="tab">
      <a href="#accessibility_pane" id="accessibility" role="tab" data-toggle="tab">Accessibility</a>
    </li>
  </ul>
  <div class="tab-content">
    <div role="tabpanel" class="tab-pane active" id="course_map_pane"></div>
    <div role="tabpanel" class="tab-pane" id="accessibility_pane">
      <div class="row">
        <div class="col-md-12">
          <a class="btn btn-default btn-xs" href="#developer/accessibility">Full Course Accessibility Report</a>
          <a class="btn btn-default btn-xs" href="https://chrome.google.com/webstore/detail/accessibility-developer-t/fpkknkljclfencbdbgkenhalefipecmb?hl=en" target="_blank">Google Audit Extension</a>
          <a class="btn btn-default btn-xs" href="https://chrome.google.com/webstore/detail/wave-evaluation-tool/jbbplnpkjmmeebjpijfedlgcdilocofh?hl=en" target="_blank">WAVE Extension</a>
          <button class="btn btn-default btn-xs" id="refresh_achecker">Refresh AChecker</button>
        </div>
        <div class="achecker-report">
          <form action="http://achecker.ca/checker/index.php" method="post" id="achecker_form" target="achecker-output">
            <input type="hidden" name="pastehtml" id="achecker_html"/>
            <input type="hidden" name="enable_html_validation" value="1"/>
            <input type="hidden" name="radio_gid[]" value="8"/>
            <input type="hidden" name="checkbox_gid[]" value="8"/>
            <input type="hidden" name="rpt_format" value="1"/>
            <input type="hidden" name="validate_paste" value="Check It"/>
          </form>
          <iframe id="achecker-output" name="achecker-output"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>
